import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import PriceCard from "../../components/onboarding/PriceCard";
import { getSubscriptionPlans } from "../../network/onboarding";
import { getSalon } from "../../network/settings";
import { queryKeys } from "../../services/react-query/queryKeys";

const SubscriptionPlans = ({}: any) => {
  const intl = useIntl();
  const user = useSelector((state: any) => state?.user?.data?.user);

  const {
    data: plans,
    isLoading,
    isError,
  } = useQuery(["SubscriptionPlans"], () => getSubscriptionPlans());
  const { data, isLoading: loadSalonData } = useQuery(
    [queryKeys?.listSalon],
    () => getSalon(user?.salon?.id)
  );

  return (
    <div className="py-8 px-6 bg-[#EEF0FF] flex justify-center absolute right-0 left-0 bottom-0 top-[84px] h-full w-full">
      <div className="flex justify-center gap-4">
        {isLoading ? (
          <Spin className="flex items-center justify-center" size="large" />
        ) : (
          plans?.data?.map((e: any) => {
            // Filtering non-commission features
            const feats = e?.features?.filter(
              (feature: any) =>
                feature?.key !== "commission_new_online_bookings" &&
                feature?.key !== "commission_recurring_online_bookings"
            );

            // Filtering commission features
            const commissions = e?.features?.filter(
              (feature: any) =>
                feature?.key === "commission_new_online_bookings" ||
                feature?.key === "commission_recurring_online_bookings"
            );

            return (
              <PriceCard
                title={e.title}
                name={e.name}
                feats={feats}
                id={e.id}
                myPlanId={data?.data?.subscription_plan?.plan?.id}
                commissions={commissions}
                price={e.price}
                recommended={false}
              />
            );
          })
        )}
      </div>
    </div>
  );
};
export default SubscriptionPlans;
